let accordUtil = {
  getAccordDOM: function (accordForm) {
    let prefix = `<html>
                            <head>
                              <title>Certificate of Property Insurance</title>
                              <style type = "text/css">
                                    body {
                                      font-family: Arial,Helvetica Neue,Helvetica,sans-serif; 
                                  }
                                  table {
                                    border-collapse: collapse;
                                  }
    
                                  table,
                                  td,
                                  th {
                                    border: 1px solid black;
                                    padding: 0px;
                                    font-size: 9px;
                                    margin: 3px 0px 3px 0px;
                                  }
    
                                  tr td .pro {
                                    vertical-align: middle;
                                    display: table-cell;
                                    padding-left: 3px;
                                    line-height: 24px;
                                  }
    
                                  tr td .con {
                                    float: left;
                                    padding-left: 3px;
                                    line-height: 20px;
                                  }
    
                                  tr td .spn {
                                    margin-left: 3px;
                                  }
    
                                  td {
                                    padding-left: 4px;
                                    padding-right: 4px;
                                  }
    
                                  hr {
                                    border: 0;
                                    height: 1px;
                                    background: #000000;
                                  }
    
                                  .rmbottom {
                                    border-bottom: none;
                                  }
    
                                  .rmtop {
                                    border-top: none;
                                  }
    
                                  .rmbt {
                                    border-bottom: none;
                                    border-top: none;
                                  }
    
                                  .sm {
                                    height: 10px;
                                    width: 80%;
                                  }
    
                                  .sm1 {
                                    height: 20px;
                                    width: 20px;
                                  }
    
                                  .lg {
                                    height: 20px;
                                    width: 100%;
                                  }
    
                                  .lg-textarea {
                                    height: 90px;
                                    width: 100%;
                                    resize: none;
                                  }
    
                                  .md-textarea {
                                    height: 40px;
                                    width: 100%;
                                    resize: none;
                                  }
    
                                  .lg-80 {
                                    height: 20px;
                                    width: 80%;
                                    margin-left: 20px;
                                  }
    
                                  .lg-70 {
                                    height: 20px;
                                    width: 70%;
                                  }
    
                                  .lg-60 {
                                    height: 20px;
                                    width: 60%;
                                  }
    
                                  .lg-40 {
                                    height: 20px;
                                    width: 40%;
                                  }
    
                                  .lg-30 {
                                    height: 20px;
                                    width: 30%;
                                  }
    
                                  tr td .txt {
                                    width: 60px;
                                    height: 20px;
                                    padding-left: 3px;
                                  }
    
                                  tr td .txt1 {
                                    width: 100px;
                                    height: 20px;
                                    padding-left: 3px;
                                  }
    
                                  div .daytag {
                                    border: 1px solid;
                                    width: 15%;
                                    text-align: center;
                                    border-bottom: none;
                                    font-size: 8px;
                                    margin-top: -30px;
                                    clear: both;
                                    float: right;
                                    margin-right: 3px;
                                  }
    
                                  .title {
                                    text-align: center;
                                    font-size: 22px;
                                    font-weight: bold;
                                  }
    
                                  th {
                                    text-align: center;
                                  }
    
                                  textarea {
                                    background-color: #eff0ff;
                                    border: none;
                                    padding: 5px 5px 5px 5px;
                                    font-weight: 500;
                                  }
    
                                  input {
                                    border: none;
                                    border-color: transparent;
                                    font-size: 10px;
                                    background-color: #eff0ff;
                                    font-weight: 500;
                                  }
    
                                  input[type="checkbox"] {
                                    -webkit-appearance: initial;
                                    appearance: initial;
                                    background: #D1D1D1;
                                    width: 20px;
                                    height: 20px;
                                    border: none;
                                    background: #CECCCC;
                                    position: relative;
                                    float: left;
                                    margin: 0px 0px 0px 0px;
                                    background-color: #eff0ff;
                                  }
    
                                  input[type="checkbox"]:checked {
                                    background: #FFFCFC;
                                    margin: 0px 0px 0px 0px;
                                  }
    
                                  input[type="checkbox"]:checked:after {
                                    content: "\\2715";
                                    color: #000000;
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    -webkit-transform: translate(-50%, -50%);
                                    -moz-transform: translate(-50%, -50%);
                                    -ms-transform: translate(-50%, -50%);
                                    transform: translate(-50%, -50%);
                                    margin: 0px 0px 0px 0px;
                                  }
    
                                  div {
                                    font-size: 9px;
                                    font-weight: normal;
                                    margin: 0px 0px 0px 0px;
                                    padding: 0px 0px 0px 0px;
                                  }
    
                                  .content1 {
                                    font-size: 11px;
                                    font-weight: bold;
                                    padding-left: 20px;
                                  }
    
                                  .content2 {
                                    margin-top: -18px;
                                  }
    
                                  .content3 {
                                    font-size: 9px;
                                    font-weight: bold;
                                  }
    
                                  .content4 {
                                    font-size: 11px;
                                    padding-left: 15px;
                                  }
    
                                  .content5 {
                                    font-size: 9px;
                                    font-weight: bold;
                                  }
    
                                  .content6 {
                                    padding: 5px 10px 10px 5px;
                                  }
    
                                  #middle_part td {
                                    font-weight: bold;
                                    border: none !important;
                                    font-size: 12px;
                                  }
    
                                  #middle_part2 td {
                                    font-weight: bold;
                                    border: none !important;
                                    font-size: 12px;
                                  }
    
                                  .textcenter {
                                    text-align: center;
                                  }
    
                                  #piece {
                                    position: absolute;
                                    float: right;
                                    top: 5px;
                                    right: 0px;
                                    text-align: center;
                                  }
    
                                  .span-checkbox {
                                    height: 15px;
                                    width: 15px;
                                    padding-top: 3px;
                                    float: left;
                                    text-align: center;
                                  }
    
                                  .additional-remarks-header {
                                    padding-top: 100px;
                                  }
    
                                  .remarks-textarea {
                                    min-height: 800px;
                                    width: 100%;
                                    resize: none;
                                  }
    
                                  .pdf-input {
                                    font-weight: 700;
                                    font-size: 11.5px;
                                  }
                              </style>
                            </head>
                            <body>
            `
    return prefix + accordForm + '</body></html>'
  }
}

export default accordUtil



// WEBPACK FOOTER //
// ./src/utilities/accord-util.js